var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0693 8.50965L9.50929 4.22965C3.75929 1.34965 1.39929 3.70965 4.27929 9.45965L5.14929 11.1996C5.39929 11.7096 5.39929 12.2996 5.14929 12.8096L4.27929 14.5396C1.39929 20.2896 3.74929 22.6496 9.50929 19.7696L18.0693 15.4896C21.9093 13.5696 21.9093 10.4296 18.0693 8.50965ZM14.8393 12.7496H9.43929C9.02929 12.7496 8.68929 12.4096 8.68929 11.9996C8.68929 11.5896 9.02929 11.2496 9.43929 11.2496H14.8393C15.2493 11.2496 15.5893 11.5896 15.5893 11.9996C15.5893 12.4096 15.2493 12.7496 14.8393 12.7496Z",
    fill: "#755EFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.851a4d6c64a2e5220e477cc149b74867.svg";
export { ForwardRef as ReactComponent };